export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Bejelentkezés",
    "login.form.hint.user": "Felhasználónév",
    "login.form.hint.password": "Jelszó",
    "login.form.checkbox.remember-me": "Emlékezzen rám",
    "login.form.button.sign-in": "Bejelentkezés",
    "login.form.message.invalid-user-credentials": "A felhasználónév vagy jelszó helytelen",
    "login.form.message.account-temporarily-locked": "Átmenetileg zároltuk a fiókját. Látogasson vissza öt perc múlva.",
    "login.form.message.user-required": "Felhasználónév beírása",
    "login.form.message.password-required": "Jelszó beírása",
    "login.form.button.forgot-password": "Elfelejtett jelszó?",
    "error.mfa-required.title": "A 2FA beállítása",
    "error.mfa-required.message1": "A fiókja védelme érdekében a kétfaktoros hitelesítés (2FA) használatára van szükség.",
    "error.mfa-required.message2": "A rendszer átirányítja az online irányítópulton található fiókbeállításokhoz. Kapcsolja be a 2FA-t, kövesse a beállítási utasításokat, majd térjen vissza ide.",
    "error.mfa-required.learnMore": "Tovább információk a 2FA-ról",
    "error.mfa-required.continue": "Folytatás",
    "error.root-admin-login.title": "403-as hiba: hozzáférés letiltva",
    "error.root-admin-login.message": "Csak olvasásra jogosult adminisztrátorként jelentkezett be. A Web Recovery-konzol használatához az ügyfélbérlő felhasználójaként vagy adminisztrátoraként kell bejelentkeznie.",
    "error.server-busy.message": "A kiszolgáló foglalt, próbálkozzon újra később.",
    "error.network-connection.title": "Hálózati hiba történt",
    "error.network-connection.message": "Ellenőrizze az internetkapcsolatot, és próbálkozzon újra.",
    "error.internal-server-error.title": "Belső kiszolgálóhiba történt",
    "error.internal-server-error.message": "Forduljon az ügyfélszolgálathoz, és tudassa velük a hiba alábbi részleteit:",
    "error.internal-server-error.copy.button": "Másolás"
};
